import { buildReducer, UnifiedGroup, isJoinedGroup } from '../../../../shared';
import {
    loadUserUnifiedGroupsCompletedAction,
    initGroupsHubWithPrefetchDataAction,
    leaveGroupCompletedAction,
    joinGroupCompletedAction,
    getGroupDetailsCompletedAction,
    handleSoftDeletedGroupCompletedAction,
} from '../../../../hub';
import {
    lpcLeaveGroupCompletedAction,
    lpcDemoteSelfCompletedAction,
    lpcJoinGroupCompletedAction,
} from '../../../actions';
import { UnifiedGroupAccessType } from '../../../../service';

export default buildReducer<string[]>()
    .handleDataAction(initGroupsHubWithPrefetchDataAction, (state, action) => {
        return updateJoinedGroupIds(action.payload.unifiedGroups);
    })
    .handleDataAction(loadUserUnifiedGroupsCompletedAction, (state, action) => {
        return updateJoinedGroupIds(action.payload.unifiedGroups);
    })
    .handleDataAction(getGroupDetailsCompletedAction, (state, action) => {
        if (action.payload.group && !action.payload.group.isMember) {
            return state.filter(group => group !== action.payload.group.hubPersonaId);
        }

        return state;
    })
    .handleDataAction(leaveGroupCompletedAction, (state, action) => {
        return state.filter(group => group !== action.payload.hubPersonaId);
    })
    .handle(lpcLeaveGroupCompletedAction, (state, action) => {
        return state.filter(group => group !== action.payload.hubPersonaId);
    })
    .handleDataAction(joinGroupCompletedAction, (state, action) => {
        if (action.payload.group.accessType === UnifiedGroupAccessType.Public) {
            return state.concat(action.payload.group.hubPersonaId);
        }

        return state;
    })
    .handle(lpcJoinGroupCompletedAction, (state, action) => {
        if (action.payload.accessType === UnifiedGroupAccessType.Public) {
            return state.concat(action.payload.hubPersonaId);
        }
        return state;
    })
    .handle(lpcDemoteSelfCompletedAction, (state, action) => {
        return [action.payload.hubPersonaId].concat(state);
    })
    .handle(handleSoftDeletedGroupCompletedAction, (state, action) => {
        return state.filter(group => group !== action.payload.hubPersonaId);
    })
    .done([]);

function updateJoinedGroupIds(groups: UnifiedGroup[]): string[] {
    if (!groups || groups.length === 0) {
        return [];
    }

    return groups
        ? groups.filter(group => isJoinedGroup(group)).map(group => group.hubPersonaId)
        : [];
}
export type { Action } from '../../../../shared';
